'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var interact = _interopDefault(require('interactjs'));
var Scrollbar = _interopDefault(require('smooth-scrollbar'));

var version = "0.0.1";

var rgex = /((?:(http|https|Http|Https|rtsp|Rtsp):\/\/(?:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,64}(?:\:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,25})?\@)?)?((?:(?:[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}\.)+(?:(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])|(?:biz|b[abdefghijmnorstvwyz])|(?:cat|com|coop|c[acdfghiklmnoruvxyz])|d[ejkmoz]|(?:edu|e[cegrstu])|f[ijkmor]|(?:gov|g[abdefghilmnpqrstuwy])|h[kmnrtu]|(?:info|int|i[delmnoqrst])|(?:jobs|j[emop])|k[eghimnrwyz]|l[abcikrstuvy]|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])|(?:name|net|n[acefgilopruz])|(?:org|om)|(?:pro|p[aefghklmnrstwy])|qa|r[eouw]|s[abcdeghijklmnortuvyz]|(?:tel|travel|t[cdfghjklmnoprtvwz])|u[agkmsyz]|v[aceginu]|w[fs]|y[etu]|z[amw]))|(?:(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[0-9])))(?:\:\d{1,5})?)(\/(?:(?:[a-zA-Z0-9\;\/\?\:\@\&\=\#\~\-\.\+\!\*\'\(\)\,\_])|(?:\%[a-fA-F0-9]{2}))*)?(?:\b|$)/gi;

var isResizing = false;
var percentWidth = 50;

var player$1 = void 0;

function toHHMMSS(sec) {
  if (typeof sec === 'number') {
    var seconds = Math.floor(sec),
        hours = Math.floor(seconds / 3600);
    seconds -= hours * 3600;
    var minutes = Math.floor(seconds / 60);
    seconds -= minutes * 60;

    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    return hours + ':' + minutes + ':' + seconds;
  } else {
    return sec;
  }
}

function toSeconds(hms) {
  var a = hms.split(':'); // split it at the colons

  // minutes are worth 60 seconds. Hours are worth 60 minutes.
  return +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
}

function urlify(text) {
  var urlRegex = rgex;
  return text.replace(urlRegex, function (url) {
    return '<a href="' + url + '">' + url + '</a>';
  });
}

function updateTime$1(var_player) {
  player$1 = var_player;
  setCueChapter(player$1.currentTime());
  setCueSlides(player$1.currentTime());
}

function changeSlide(ev) {
  var currentTime = ev.target.getAttribute("data-timecode");
  if (currentTime !== null) {
    if (!isNumeric(currentTime)) currentTime = toSeconds(currentTime);
    playerRM.currentTime(currentTime);
  }
}

function changeChapter(ev) {
  var currentTime = ev.target.getAttribute("data-timecode");
  if (currentTime !== null) {
    if (!isNumeric(currentTime)) currentTime = toSeconds(currentTime);
    playerRM.currentTime(currentTime);
  }
}

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function setCueChapter(currentTime) {
  var transformY = 0;
  if (player$1.$("#vjs-chapter-container") !== null && player$1.$("#vjs-chapter-container").children !== null && player$1.$("#vjs-chapter-container").children.length > 0) {
    var plusX = document.getElementById("vjs-chapter-container").offsetHeight - document.getElementById("navigation-content").offsetHeight;
    var active, i, line, begin, end;
    var lines = player$1.$("#vjs-chapter-container").children;

    for (i = 0; i < lines.length; i++) {
      line = lines[i];
      transformY = transformY + line.offsetHeight + 8;
      begin = line.getAttribute('data-timecode');
      if (i < lines.length - 1) {
        end = lines[i + 1].getAttribute('data-timecode');
      } else {
        end = player$1.duration() || Infinity;
      }
      if (1 * currentTime >= 1 * begin && 1 * currentTime < 1 * end) {
        if (!line.classList.contains('is-active')) {
          // don't update if it hasn't changed
          line.classList.add('is-active');
          if (plusX) {
            transformY = transformY - document.getElementById("navigation-content").offsetHeight;
            transformY = transformY > 0 ? transformY > plusX ? plusX : transformY : 0;
            if (document.querySelector(".richMedia-navigation-show .scroll-content")) document.querySelector(".richMedia-navigation-show .scroll-content").style.transform = "translate3d(0px, -" + transformY + "px, 0px)";
          }
          //currentTime.body.scroll.to(line);
        }
      } else {
        line.classList.remove('is-active');
      }
    }
  }
}

function setCueSlides(currentTime) {
  if (player$1.$("#vjs-sliders-content") !== null && player$1.$("#vjs-sliders-content").children !== null && player$1.$("#vjs-sliders-content").children.length > 0) {
    var active, i, line, begin, end, type, path;
    var plusX = document.querySelector(".vjs-sliders-content .scroll-content").offsetWidth - document.getElementById("vjs-sliders-content").offsetWidth;
    var lines = document.querySelectorAll('.vjs-sliders-field');

    for (i = 0; i < lines.length; i++) {
      line = lines[i];
      begin = line.getAttribute('data-timecode');
      if (i < lines.length - 1) {
        end = lines[i + 1].getAttribute('data-timecode');
      } else {
        end = player$1.duration() || Infinity;
      }

      if (1 * currentTime >= 1 * begin && 1 * currentTime < 1 * end) {
        if (!line.classList.contains('is-active')) {
          // don't update if it hasn't changed
          type = line.getAttribute('data-type');
          var transformX = i * line.offsetWidth;
          if (plusX) {
            transformX = transformX - document.getElementById("vjs-sliders-content").offsetWidth;
            transformX = transformX > 0 ? transformX > plusX ? plusX + line.offsetWidth : transformX + line.offsetWidth : 0;
            if (player$1.$("#vjs-sliders-content").children[0]) player$1.$("#vjs-sliders-content").children[0].style.transform = "translate3d(-" + transformX + "px, 0px, 0px)";
          }

          line.classList.add('is-active');
          path = line.getAttribute('data-path');
          var video = document.getElementById("slide-video");
          var image = document.getElementById("slide-image");
          if (type === "image" || type === "Image") {
            image.src = path;
            image.classList.add('show-slide');
            video.classList.add('hide-slide');
            video.classList.remove('show-slide');
            image.classList.remove('hide-slide');
            video.src = "";
          } else {
            video.src = path;
            image.classList.remove('show-slide');
            video.classList.remove('hide-slide');
            video.classList.add('show-slide');
            image.classList.add('hide-slide');
          }
          //currentTime.body.scroll.to(line);
        }
      } else {
        line.classList.remove('is-active');
      }
    }
  }
}

function resizeSlide(player_id) {
  isResizing = true;
  var player = videojs.getPlayer(player_id);
  var percent = 100;
  var isNavigation = document.getElementsByClassName('vjs-navigation-container-show');
  document.onmouseup = function (e) {
    // stop resizing
    isResizing = false;
    player.removeClass('no-select');
  };
  document.onmousemove = function (e) {
    // we don't want to do anything if we aren't resizing.
    if (!isResizing) return;
    if (isNavigation && isNavigation.length > 0) {
      percent = 75;
    }
    var offsetRight = player.el().offsetWidth - e.clientX;
    percentWidth = Math.round(offsetRight / player.el().offsetWidth * 100);
    resize();
    player.addClass('no-select');
  };

  function hasClass(element, className) {
    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
  }

  function resize() {
    var videos = document.getElementsByClassName('vjs-tech');
    var posters = document.getElementsByClassName('vjs-poster');

    var video = videos && videos[0] ? videos[0] : null;
    var poster = posters && posters[0] ? posters[0] : null;
    var slide = document.getElementById('vjs-slide-items');
    var percentVideo = percent - percentWidth;
    var percentSlide = percentWidth;
    if (percent - percentWidth < 0.0001) {
      percentVideo = 0;
      percentSlide = 75;
    }
    if (hasClass(video, "is-right")) {
      var percentRight = percentVideo;
      percentVideo = percentSlide;
      percentSlide = percentRight;
    }
    video.style.width = percentVideo + "%";
    poster.style.width = percentVideo + "%";
    slide.style.width = percentSlide + "%";
  }
}

var utils = {
  toHHMMSS: toHHMMSS,
  urlify: urlify,
  updateTime: updateTime$1,
  changeSlide: changeSlide,
  changeChapter: changeChapter
};

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component = videojs.getComponent('Component');
var ChapterContainer = videojs.getComponent('ChapterContainer');
/**
 * send mail button.
 */
var chapterContainer = void 0;

var Chapters = function (_Component) {
  inherits(Chapters, _Component);

  function Chapters(player, options) {
    classCallCheck(this, Chapters);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.options = options;
    _this._createContent();
    return _this;
  }

  Chapters.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-chapters'
    });
  };

  Chapters.prototype._createContent = function _createContent() {
    chapterContainer = this.addChild('ChapterContainer', this.options);
  };

  Chapters.prototype.searchChapter = function searchChapter(searchText) {
    chapterContainer.emptyEl();
    if (searchText && searchText !== "") {
      var resultSearch = this.options.chapters.filter(searchChapter, searchText);
      chapterContainer._content(resultSearch);
    } else {
      chapterContainer._content(this.options.chapters);
    }

    function searchChapter(chapter) {
      return chapter.title.indexOf(this[0]) >= 0;
    }
  };

  return Chapters;
}(Component);

var Component$1 = videojs.getComponent('Component');
var ChapterField = videojs.getComponent('ChapterField');
/**
 * send mail button.
 */

var ChapterContainer$1 = function (_Component) {
  inherits(ChapterContainer, _Component);

  function ChapterContainer(player, options) {
    classCallCheck(this, ChapterContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this.chapters = options.chapters;
    _this.length = options.chapters.length;
    _this._content(_this.chapters);
    _this.on("setCueChapter", _this.triggerSetCueChapter);
    var self = _this;
    window.playerRM.on("chapterLiveAdded", function (event, chapters) {
      if (chapters && chapters.length > self.length) {
        for (var i = self.length; i < chapters.length; i++) {
          var chapterField = self.addChild('ChapterField', ChapterField);
          chapterField._content(chapters[i], i);
          self.el_.scrollTop = self.el_.scrollHeight;
        }
        self.length = chapters.length;
      }
    });
    return _this;
  }

  ChapterContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'vjs-chapter-container',
      className: 'vjs-chapter-container'
    });
  };

  ChapterContainer.prototype._content = function _content(chapters) {
    if (chapters) {
      for (var i = 0; i < chapters.length; i++) {
        var chapterField = this.addChild('ChapterField', ChapterField);
        chapterField._content(chapters[i], i);
        this.el_.scrollTop = this.el_.scrollHeight;
      }
    }
  };

  ChapterContainer.prototype.emptyEl = function emptyEl() {
    videojs.dom.emptyEl(this.el());
  };

  ChapterContainer.prototype.triggerSetCueChapter = function triggerSetCueChapter(event, data) {
    var chapterField = this.addChild('ChapterField', ChapterField);
    chapterField._content(data);
    this.el_.scrollTop = this.el_.scrollHeight;
  };

  return ChapterContainer;
}(Component$1);

var Component$2 = videojs.getComponent('Component');
var ChapterField$1 = function (_Component) {
  inherits(ChapterField, _Component);

  function ChapterField(player, options) {
    classCallCheck(this, ChapterField);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    return _this;
  }

  ChapterField.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-chapter-field'
    });
  };

  ChapterField.prototype._content = function _content(chapter, id) {
    this.el_.id = 'vjs-chapter-field-' + id;
    this.el_.setAttribute("data-timecode", chapter.timecode);
    this.el_.onclick = changeChapter;

    var chapterBuild = '\n      <p class="vjs-chapter-field-title" data-timecode="' + chapter.timecode + '">\n          ' + utils.urlify(chapter.title) + '\n      </p>\n    <p class="vjs-chapter-field-timecode" data-timecode="' + chapter.timecode + '">\n        ' + utils.toHHMMSS(chapter.timecode) + '\n    </p>\n\n    ';
    this.el_.innerHTML = chapterBuild;

    function changeChapter(ev) {
      utils.changeChapter(ev);
    }
  };

  return ChapterField;
}(Component$2);

var Component$3 = videojs.getComponent('Component');
var SlidersContainer = function (_Component) {
  inherits(SlidersContainer, _Component);

  function SlidersContainer(player, options) {
    classCallCheck(this, SlidersContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addChild('SlidersContent', options.slides);
    _this.closeSliders();

    return _this;
  }

  // The `createEl` function of a component creates its DOM element.


  SlidersContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {

      // Prefixing classes of elements within a player with "vjs-"
      // is a convention used in Video.js.
      id: "sliders-container",
      className: 'vjs-sliders-container no-select'
    });
  };

  // This function could be called at any time to update the text
  // contents of the component.


  SlidersContainer.prototype.openSliders = function openSliders(type) {
    this.addClass('vjs-sliders-container-show');
    this.player().addClass('vjs-sliders-container-show');

    this.getChild('SlidersContent').setContent(type);
  };

  SlidersContainer.prototype.closeSliders = function closeSliders() {

    this.removeClass('vjs-sliders-container-show');
    this.player().removeClass('vjs-sliders-container-show');
  };

  return SlidersContainer;
}(Component$3);

var Component$4 = videojs.getComponent('Component');

var SlidersContent = function (_Component) {
  inherits(SlidersContent, _Component);

  function SlidersContent(player, options) {
    classCallCheck(this, SlidersContent);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this.sliders = options;
    _this.length = options.length;
    _this._content();
    var self = _this;
    window.playerRM.on("slideLiveAdded", function (event, slides) {
      if (slides && slides.length > self.length) {
        self.player.classList.add("vjs-rich-media-with-slide");
        for (var i = self.length; i < slides.length; i++) {
          var slideField = self.addChild('SlidersField', {});
          slideField._content(slides[i], i);
          self.el_.scrollTop = self.el_.scrollHeight;
        }
        self.length = slides.length;
      }
    });
    return _this;
  }

  SlidersContent.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'vjs-sliders-content',
      className: 'vjs-sliders-content'
    });
  };

  SlidersContent.prototype._content = function _content() {
    if (this.sliders && this.sliders.length > 0) {
      for (var i = 0; i < this.sliders.length; i++) {
        var slideField = this.addChild('SlidersField', {});
        slideField._content(this.sliders[i], i);
        this.el_.scrollTop = this.el_.scrollHeight;
      }
    }
  };

  return SlidersContent;
}(Component$4);

var Component$5 = videojs.getComponent('Component');
var SlidersField = function (_Component) {
  inherits(SlidersField, _Component);

  function SlidersField(player, options) {
    classCallCheck(this, SlidersField);
    return possibleConstructorReturn(this, _Component.call(this, player, options));
  }

  SlidersField.prototype.createEl = function createEl() {
    return videojs.dom.createEl('ANY', {
      className: 'vjs-sliders-field'
    });
  };

  SlidersField.prototype._content = function _content(slide, id) {
    this.el_.id = 'vjs-sliders-field-' + id;
    this.el_.setAttribute("data-timecode", slide.timecode);
    this.el_.setAttribute("data-type", slide.type);
    this.el_.onclick = changeSlide;
    var src = slide.type === 'Image' || slide.type === 'image' ? slide.src : slide.src.replace(new RegExp('.mp4$'), ".jpg");
    this.el_.setAttribute("data-path", slide.src);

    this.el_.innerHTML = '\n                <img class="vjs-sliders-field-thumb"\n                     src="' + src + '"\n                     data-timecode="' + slide.timecode + '">\n                <div class="vjs-sliders-field-timecode" data-timecode="' + slide.timecode + '">' + utils.toHHMMSS(slide.timecode) + '</div>';

    function changeSlide(ev) {
      utils.changeSlide(ev);
    }
  };

  return SlidersField;
}(Component$5);

var Component$6 = videojs.getComponent('Component');
var SlideField = videojs.getComponent('SlideField');
/**
 * send mail button.
 */

var Slide = function (_Component) {
  inherits(Slide, _Component);

  function Slide(player, options) {
    classCallCheck(this, Slide);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.options = options;
    _this._createContent();
    return _this;
  }

  Slide.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-slide'
    });
  };

  Slide.prototype._createContent = function _createContent() {
    this.addChild('SlideField', this.options);
  };

  return Slide;
}(Component$6);

var Component$7 = videojs.getComponent('Component');
window.resizeSlide = resizeSlide;

var SlideField$1 = function (_Component) {
  inherits(SlideField, _Component);

  function SlideField(player, options) {
    classCallCheck(this, SlideField);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this._content(player, options);
    return _this;
  }

  SlideField.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-slide-field'
    });
  };

  SlideField.prototype._content = function _content(player, chapter) {
    var id_player = player.id();

    var slideBuild = '\n    <div class="vjs-slide-items is-right" id="vjs-slide-items">\n      <div class="drag" id="drag">\n        <div class="resizer" id="resizer" onmousedown="resizeSlide(' + id_player + ')">\n          <div class="icon_resizer" id="icon_resizer" onmousedown="resizeSlide(' + id_player + ')">\n          </div>\n        </div>\n      </div>\n      <img class="vjs-big-slide-diapo" id="slide-image" src="data:image/png;base64,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" style="top: 50%;">\n      <video autoplay="" class="vjs-big-slide-diapo hide-slide" id="slide-video" src="" style=""></video>\n    </div>';
    this.el_.innerHTML = slideBuild;
  };

  return SlideField;
}(Component$7);

var Component$8 = videojs.getComponent('Component');
window.resizeSlide = resizeSlide;
var SlideInteract = function (_Component) {
    inherits(SlideInteract, _Component);

    function SlideInteract(player, options) {
        classCallCheck(this, SlideInteract);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this._content(player);
        return _this;
    }

    SlideInteract.prototype.createEl = function createEl() {
        return videojs.dom.createEl('div', {
            className: 'vjs-slide'
        });
    };

    SlideInteract.prototype._content = function _content(player) {
        this.el_.classList.add("draggable_uep");
        var videos = document.getElementsByClassName('vjs-tech');
        if (videos !== null && videos.length > 0) {
            videos[0].classList.add("draggable_uep");
        }
        var slideBuild = '\n    <img class="vjs-big-slide-diapo" id="slide-image" src="data:image/png;base64,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" style="top: 50%;">\n    <video autoplay="" class="vjs-big-slide-diapo hide-slide" id="slide-video" src="" style=""></video>';
        this.el_.innerHTML = slideBuild;

        // target elements with the "draggable" class
        interact('.draggable_uep').draggable({
            // enable inertial throwing
            inertia: true,
            // keep the element within the area of it's parent
            restrict: {
                restriction: "parent",
                endOnly: true,
                elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
            },
            // enable autoScroll
            autoScroll: true,

            // call this function on every dragmove event
            onmove: dragMoveListener,
            // call this function on every dragend event
            onend: function onend(event) {
                /*var textEl = event.target.querySelector('p');
                 textEl && (textEl.textContent =
                    'moved a distance of '
                    + (Math.sqrt(Math.pow(event.pageX - event.x0, 2) +
                        Math.pow(event.pageY - event.y0, 2) | 0))
                        .toFixed(2) + 'px');*/
            }
        }).resizable({
            // resize from all edges and corners
            edges: { left: true, right: true, bottom: true, top: true },

            // keep the edges inside the parent
            restrictEdges: {
                outer: 'parent',
                endOnly: true
            },

            // minimum size
            restrictSize: {
                min: { width: 100, height: 50 }
            },

            inertia: true
        }).on('resizemove', function (event) {
            var target = event.target,
                x = parseFloat(target.getAttribute('data-x')) || 0,
                y = parseFloat(target.getAttribute('data-y')) || 0;

            // update the element's style
            target.style.width = event.rect.width + 'px';
            target.style.height = event.rect.height + 'px';

            // translate when resizing from top or left edges
            x += event.deltaRect.left;
            y += event.deltaRect.top;

            target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px,' + y + 'px)';

            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
            //target.textContent = Math.round(event.rect.width) + '\u00D7' + Math.round(event.rect.height);
        });

        function dragMoveListener(event) {
            var target = event.target,

            // keep the dragged position in the data-x/data-y attributes
            x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
                y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

            // translate the element
            target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

            // update the posiion attributes
            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
        }

        // this is used later in the resizing and gesture demos
        window.dragMoveListener = dragMoveListener;
    };

    return SlideInteract;
}(Component$8);

var optionsScroll = {
    damping: 0.1,
    thumbMinSize: 20,
    renderByPixels: !('ontouchstart' in document),
    alwaysShowTracks: false,
    continuousScrolling: true
};

// Default options for the plugin.
var defaults = {
    thumbnailSize: 190,
    playlistItems: 3,
    hideIcons: false,
    upNext: true,
    hideSidebar: false,
    hideSliders: false,
    interact: false
};

var video_has_left = true;
var slides_has_hiden = false;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 * @param    {Object} [options={}]
 */
var onPlayerReady = function onPlayerReady(player, options) {
    window.playerRM = player;
    videojs.registerComponent('Chapters', Chapters);
    videojs.registerComponent('ChapterContainer', ChapterContainer$1);
    videojs.registerComponent('ChapterField', ChapterField$1);

    if (options.slides !== null && options.slides !== undefined && (options.slides.length > 0 || options.live)) {
        videojs.registerComponent('SlidersContainer', SlidersContainer);
        videojs.registerComponent('SlidersContent', SlidersContent);
        videojs.registerComponent('SlidersField', SlidersField);
        videojs.registerComponent('Slide', Slide);
        videojs.registerComponent('SlideInteract', SlideInteract);
        videojs.registerComponent('SlideField', SlideField$1);
        player.addChild('SlidersContainer', options);
        if (options.interact) {

            player.addChild('SlideInteract', options);
        } else {
            player.addChild('Slide', options);
        }
    }

    createElements(player, options);
};

var updateTime = function updateTime(player) {

    var timeUpdate = function timeUpdate() {
        utils.updateTime(player);
    };
    player.on('timeupdate', timeUpdate);
};
/**
 * Creates the root html elements for the playlist
 */
var createElements = function createElements(player, options) {
    player.addClass('vjs-rich-media');
    // creates the playlist items and add on the video player
    //createSlideElements(player, options);
    //createDragElements(player, options);
    // create next and previous button
    var s = Scrollbar.init(document.querySelector('#vjs-sliders-content'), optionsScroll);
    window.scrollBarSlides = s;
    document.getElementById("vjs-sliders-content").addEventListener("wheel", myFu);
    function myFu(e) {
        var elements = document.getElementsByClassName("scroll-content");
        var x = s.offset !== null && s.offset.x !== null ? s.offset.x : 0;
        var limitX = s.limit !== null && s.limit.x !== null ? s.limit.x : 500;
        var wheelDeltaX = x + limitX / e.wheelDelta;
        if (wheelDeltaX >= 0 && wheelDeltaX <= limitX) s.offset = { x: wheelDeltaX, y: 0 };else if (wheelDeltaX < 0) s.offset = { x: 0, y: 0 };else s.offset = { x: limitX, y: 0 };
        if (elements.length > 0) {
            var element = elements[0];
            if (wheelDeltaX >= 0 && wheelDeltaX <= limitX) {
                element.style.transform = "translate3d(-" + wheelDeltaX + "px, 0px, 0px)";
            } else if (wheelDeltaX < 0) {
                element.style.transform = "translate3d(" + wheelDeltaX * -1 + "px, 0px, 0px)";
            } else {
                element.style.transform = "translate3d(-" + limitX + "px, 0px, 0px)";
            }
        }
    }
    if (!defaults.hideIcons && options.slides !== null && options.slides !== undefined && options.slides.length > 0) {

        var changeBtn = document.createElement("button");
        changeBtn.className = "vjs-button-changeBtn";
        changeBtn.onclick = changeSlideVideo;

        player.controlBar.el().insertBefore(changeBtn, player.controlBar.fullscreenToggle.el());

        if (options.hideSliders !== undefined && options.hideSliders !== true) {
            var sliderBtn = document.createElement("button");
            sliderBtn.className = "vjs-button-slider";
            sliderBtn.onclick = ShowHideSlides;

            player.controlBar.el().insertBefore(sliderBtn, player.controlBar.fullscreenToggle.el());
        } else {
            ShowHideSlides();
        }
    }

    // adds the main class on the player


    updateTime(player);
};

/**
 * plays the next video, if it comes to the end, loop
 */

var ShowHideSlides = function ShowHideSlides() {
    var video = document.querySelectorAll('.vjs-tech');
    var slide = document.querySelectorAll('.vjs-slide-items');
    var slides = document.querySelectorAll('.vjs-sliders-content');
    if (!slides_has_hiden) {
        video[0].classList.remove('slides-is-hiden');
        video[0].classList.add('slides-is-show');
        slide[0].classList.add('slides-is-show');
        slide[0].classList.remove('slides-is-hiden');
        slides[0].classList.add('slides-is-hiden');
        slides[0].classList.remove('slides-is-show');
    } else {
        slide[0].classList.remove('slides-is-show');
        slide[0].classList.add('slides-is-hiden');
        video[0].classList.add('slides-is-hiden');
        video[0].classList.remove('slides-is-show');
        slides[0].classList.add('slides-is-show');
        slides[0].classList.remove('slides-is-hiden');
    }
    slides_has_hiden = !slides_has_hiden;
};

var changeSlideVideo = function changeSlideVideo() {
    var video = document.querySelectorAll('.vjs-tech');
    var slide = document.querySelectorAll('.vjs-slide-items');
    if (video_has_left) {
        video[0].classList.remove('is-left');
        video[0].classList.add('is-right');
        slide[0].classList.add('is-left');
        slide[0].classList.remove('is-right');
    } else {
        slide[0].classList.remove('is-left');
        slide[0].classList.add('is-right');
        video[0].classList.add('is-left');
        video[0].classList.remove('is-right');
    }
    video_has_left = !video_has_left;
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function richMedia
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var richMedia = function richMedia(options) {
    var _this = this;

    this.ready(function () {
        onPlayerReady(_this, videojs.mergeOptions(defaults, options));
    });
};

// Register the plugin with video.js.
videojs.registerPlugin('richMedia', richMedia);

// Include the version number.
richMedia.VERSION = version;

module.exports = richMedia;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_rich_media/dist/videojs-rich-media.cjs.js
// module id = 629
// module chunks = 0